/* Amorae - keep bundle products at a quantity that always earns the bundle discount.

   The store runs one automatic discount: 50% off Batana Silk Oil when the cart holds
   2 or more. That is the same economics as Buy 1 Get 1 Free, but it renders as a single
   clean cart line instead of a paid line plus a free line.

   This script keeps the quantity at 2 or more so the deal never silently falls off.
   Customers can still remove the line entirely with the bin icon. */
(function () {
  var HANDLES = ['batana-silk-oil'];
  var MIN = 2;

  function rowOf(el) {
    return el.closest('.cart-item, tr.cart-item, .cart-drawer__item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');
  }

  function isBundleRow(row) {
    if (!row) return false;
    var link = row.querySelector('a[href*="/products/"]');
    if (!link) return false;
    var href = link.getAttribute('href') || '';
    return HANDLES.some(function (h) { return href.indexOf('/products/' + h) !== -1; });
  }

  function apply() {
    document.querySelectorAll('input[name^="updates["]').forEach(function (input) {
      if (input.dataset.amBundle === 'done') return;
      var row = rowOf(input);
      if (!isBundleRow(row)) return;
      input.dataset.amBundle = 'done';
      input.min = MIN;
      var current = parseInt(input.value, 10);
      if (!isNaN(current) && current > 0 && current < MIN) input.value = MIN;
    });
  }

  // A quantity of 1 loses the discount, so lift it back to 2 before the theme reads it.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.name || input.name.indexOf('updates[') !== 0) return;
    if (!isBundleRow(rowOf(input))) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) return;
    if (value > 0 && value < MIN) input.value = MIN;   // 0 still removes the line
  }, true);

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(apply, 80);
  }

  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:update', schedule);
  if (document.readyState !== 'loading') apply();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
